import { KindAllNodeStoreProvider } from '../Store'

import { KindAllNodeCascaderCore } from './Core'
import { KindAllNodeCascaderProps } from './interface'

export const KindAllNodeCascader = <M extends boolean>({
  /* -------------------------------------------------------------------------- */
  /*                       KindAllNodeStoreProvider Props                       */
  /* -------------------------------------------------------------------------- */
  multiple,
  value,
  onChange,
  /* -------------------------------------------------------------------------- */
  /*                        KindAllNodeCascaderCore Props                       */
  /* -------------------------------------------------------------------------- */
  ...restProps
}: KindAllNodeCascaderProps<M>) => {
  return (
    <KindAllNodeStoreProvider
      multiple={multiple}
      value={value}
      onChange={onChange}
    >
      <KindAllNodeCascaderCore {...restProps} />
    </KindAllNodeStoreProvider>
  )
}
